/** Textos da secção "login". Chaves planas "login.*"; "pt" é a fonte, "en" a tradução. */
const pt = {
    "login.eyebrow": "ZRS Account",
    "login.title": "Entrar com Discord",
    "login.desc":
        "A conta ZRS liga-se à tua conta Discord via Supabase. Novos jogadores criam conta no primeiro login.",
    "login.redirecting": "A redirecionar…",
    "login.continueDiscord": "Continuar com Discord",
    "login.errorNotConfigured": "Supabase não configurado.",
    "login.errorStart": "Não foi possível iniciar o login com Discord.",
    // App.js — erros do callback OAuth e título da rota do simulador
    "login.errorExchange":
        "Discord: troca do código falhou (Supabase ↔ Discord). Confirma Client Secret e Redirect no painel.",
    "login.errorComplete": "Não foi possível completar o login.",
    "login.simulatorTitle": "Simulador VIP personalizado",
};
const en = {
    "login.eyebrow": "ZRS Account",
    "login.title": "Sign in with Discord",
    "login.desc":
        "Your ZRS account is linked to your Discord account via Supabase. New players get an account on their first login.",
    "login.redirecting": "Redirecting…",
    "login.continueDiscord": "Continue with Discord",
    "login.errorNotConfigured": "Supabase is not configured.",
    "login.errorStart": "Couldn't start Discord login.",
    "login.errorExchange":
        "Discord: code exchange failed (Supabase ↔ Discord). Check the Client Secret and Redirect URL in the dashboard.",
    "login.errorComplete": "Couldn't complete sign-in.",
    "login.simulatorTitle": "Custom VIP simulator",
};

export default { pt, en };
